export default __webpack_public_path__ + "static/media/meslay3.9e453692.jpg";